import { io } from 'socket.io-client';
import { API_URL } from './api';
import { getToken } from './auth';

// Lazily-created shared socket for the authenticated messenger. The token is
// passed in the handshake `auth` so the backend's chat.socket.js can resolve
// the user (presence, typing, delivery, read receipts).
let socket = null;

export function getSocket() {
  if (!socket) {
    socket = io(API_URL, {
      auth: { token: getToken() },
      transports: ['websocket'],
      autoConnect: true,
    });
  }
  return socket;
}

// Call on logout / token change so the next getSocket() re-handshakes with a
// fresh (or absent) token.
export function disconnectSocket() {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}
